import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=961df256&scoped=true&"
import script from "./notification.js?vue&type=script&lang=js&"
export * from "./notification.js?vue&type=script&lang=js&"
import style0 from "./notification.scss?vue&type=style&index=0&id=961df256&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961df256",
  null
  
)

export default component.exports